import { getLang, isReview } from "@/i18n";
import { enterReview, exitReview } from "@/components/ReviewLayer";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/LogoMark";

export const SiteFooter = () => (
  <footer className="relative z-10 border-t border-[#1C242B]/10 mt-24 no-print">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 flex flex-col md:flex-row gap-4 justify-between text-sm text-slate-500">
      <p className="flex items-center gap-2">
        <LogoMark className="w-6 h-6 shrink-0" />
        <span><span className="font-display font-semibold text-[#1C242B]">Aptitude Plus</span>: a free, humanitarian self-discovery tool.</span>
      </p>
      {getLang() !== "en" && (
        <button data-testid="review-mode-toggle" data-review-ui onClick={isReview() ? exitReview : enterReview} className="text-[#3E6B5C] underline underline-offset-4 hover:text-[#1C242B] transition-colors">
          {isReview() ? "Exit translation review" : "Help improve this translation"}
        </button>
      )}
      <div className="flex gap-4">
        <Link to="/thanks" data-testid="footer-thanks-link" className="hover:text-[#1C242B] transition-colors">Our translators</Link>
        <Link to="/translations/review" data-testid="footer-reviewer-signin-link" className="hover:text-[#1C242B] transition-colors">Reviewer sign-in</Link>
      </div>
      <p className="max-w-xl">Not an accredited psychometric or clinical assessment. Results are guidance, not a verdict. Pay ranges are approximate US figures.</p>
    </div>
  </footer>
);
